/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2025 (original work) Open Assessment Technologies SA ;
 */

/**
 * Compare semver versions,
 * for simple cases like 1.22.33 - doesn't check postfix, doesn't properly validate version
 * @param {String} versionA
 * @param {String} versionB
 * @returns {Number|void 0} 1 if A newer than B; 0 if A equal to B; -1 if A older than B; undefined if versions are not valid
 */
export function semverCompare(versionA, versionB) {
    const parsedA = typeof versionA === 'string' && semverParse(versionA);
    const parsedB = typeof versionB === 'string' && semverParse(versionB);
    if (!parsedA || !parsedB) {
        return void 0;
    }
    if (parsedA[0] !== parsedB[0]) {
        return parsedA[0] - parsedB[0] > 0 ? 1 : -1;
    }
    if (parsedA[1] !== parsedB[1]) {
        return parsedA[1] - parsedB[1] > 0 ? 1 : -1;
    }
    if (parsedA[2] !== parsedB[2]) {
        return parsedA[2] - parsedB[2] > 0 ? 1 : -1;
    }
    return 0;
}

function semverParse(version) {
    const regex = /^v?([0-9]+)\.([0-9]+)\.([0-9]+)/;
    const match = version.match(regex);
    if (match) {
        return [parseInt(match[1]), parseInt(match[2]), parseInt(match[3])];
    }
    return null;
}
